import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AccountType, EncashmentOperationType, PagedStoreEncashmentModel, StoreEncashmentModel, StoreEncashmentRequest, StoreEncashmentResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxStoreEncashmentService {

  constructor(private storeEncashmentResourceService: StoreEncashmentResourceService) {
  }

  getStoreEncashmentList(params: {
    page?: number,
    limit?: number,
    accountType?: AccountType,
    date?: string,
    userId?: number,
    storeId?: number,
    operationType?: EncashmentOperationType,
    includeDisabled?: boolean,
  }): Promise<PagedStoreEncashmentModel> {
    return firstValueFrom(this.storeEncashmentResourceService.getStoreEncashments(
      params.accountType, params.date, params.includeDisabled, params.limit,
      params.operationType, params.page, params.storeId, params.userId,
    ));
  }

  getStoreEncashmentById(storeEncashmentId: number): Promise<StoreEncashmentModel> {
    return firstValueFrom(this.storeEncashmentResourceService.getStoreEncashmentById(storeEncashmentId));
  }

  saveStoreEncashment(request: StoreEncashmentRequest): Promise<StoreEncashmentModel> {
    return firstValueFrom(this.storeEncashmentResourceService.saveStoreEncashment(request));
  }

  removeStoreEncashmentById(id: number): Promise<any> {
    return firstValueFrom(this.storeEncashmentResourceService.removeStoreEncashment(id));
  }
}
